var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "10px",
    viewBox: "0 0 9 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Initial-(Desktop)",
    transform: "translate(-135.000000, -294.000000)",
    fill: "#EA4335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Numbers-Copy",
    transform: "translate(110.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(25.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Red",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8047664,5.85296737 L4.81908581,9.88220993 C4.65724107,10.0392634 4.40159008,10.0392634 4.23974535,9.88220993 L0.240427277,5.85296737 C0.10672768,5.74922184 0.0200554794,5.59539399 0,5.42625762 C-0.000920430126,5.19489294 0.180783251,5.00493359 0.40963308,4.99801661 L2.82851843,4.99801661 L2.82851843,0.442532721 C2.85280864,0.198097153 3.05178819,0.00921901781 3.29471831,0 L5.76966887,0 C6.01259898,0.00921901781 6.21157853,0.198097153 6.23586874,0.442532721 L6.23586874,5.01230833 L8.65273372,5.01230833 C8.7635602,5.01322974 8.86937368,5.05910785 8.9464015,5.13963542 C9.02342932,5.22016298 9.06521232,5.32858737 9.0623633,5.44054933 C9.02947454,5.60530266 8.93779315,5.75208649 8.8047664,5.85296737 L8.8047664,5.85296737 Z",
    id: "Mask",
    transform: "translate(4.531250, 5.000000) scale(1, -1) translate(-4.531250, -5.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/arrow-red.b3efcf2d9b887384203c5f6e840cb517.svg";
export { ForwardRef as ReactComponent };